import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { SingleSelect } from "react-select-material-ui";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  RadioButtonGroup,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Layer,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Spinner,
  //IFrame,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Video,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import {
  callApiGetJson,
  callApiPostJson,
  APIServerURL,
  debugLog,
  callApiText,
  logAccess,
} from "./GlobalSettings";
import auth from "./Security/Auth";
import Iframe from "react-iframe";

class DocumentHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DocumentBlobData: undefined,
      Document_ID: this.props.Document_ID,
      DocumentURL: undefined,
      DocumentContent: this.props.DocumentContentRecord,
    };

    this._onClose = this._onClose.bind(this);
    this.GetDocumentFile = this.GetDocumentFile.bind(this);
    this.GetDocumentTokenURL = this.GetDocumentTokenURL.bind(this);
  }

  componentDidMount() {
    if (this.props.DocumentContentRecord !== undefined) {
      if (this.props.DocumentContentRecord.Content_Content_EmpLink) {
        var docURL = this.props.DocumentContentRecord.Content_CustomerLink;
        switch (this.props.UserType) {
          case "1":
            docURL = this.props.DocumentContentRecord.Content_EmpLink;
            break;
          case "2":
            docURL = this.props.DocumentContentRecord.Content_PartnerLink;
            break;
          default:
            docURL = this.props.DocumentContentRecord.Content_CustomerLink;
            break;
        }
        this.setState({
          DocumentURL: docURL,
        });
      } else {
        //this.GetDocumentFile();
        this.GetDocumentTokenURL();
      }
    } else {
      if (this.props.Document_ID !== undefined) {
        this.GetDocumentTokenURL();
      }
    }

    //this just refreshes the user token if necessary
    auth.verifyToken(true);
    if (this.props.DocumentContentRecord !== undefined) {
      logAccess(
        this.props.DocumentContentRecord.Content_ID,
        this.props.DocumentContentRecord.Content_Type,
        "ViewDocument",
        this.props.calledBy,
        auth.getToken()
      );
    } else {
      logAccess(
        this.props.Document_ID,
        "Document",
        "ViewDocument_Newsletter",
        "From HomePage",
        auth.getToken()
      );
    }
  }

  GetDocumentTokenURL() {
    var endpoint = "";
    if (
      this.props.Document_ID !== undefined &&
      this.props.DocumentContent == undefined
    ) {
      endpoint = "/DocContent/GetDocAccessToken/" + this.props.Document_ID;
    } else {
      endpoint =
        "/DocContent/GetDocAccessToken/" +
        this.props.DocumentContentRecord.Content_ID;
    }
    let token = auth.getToken();
    callApiGetJson(endpoint, token).then((data) => {
      if (data !== undefined) {
        debugLog(data);
        this.setState({
          DocumentURL: APIServerURL + "/DocContent/GetDocByToken/" + data.Token,
        });
      }
    });
  }

  GetDocumentFile() {
    var endpoint =
      "/AllContent/GetContentBase64ById/" +
      this.props.DocumentContentRecord.Content_ID;
    let token = auth.getToken();

    callApiText(endpoint, token).then((data) => {
      //getBinaryData(endpoint, token).then(data =>{
      //console.log('File data:', data);
      if (data !== undefined) {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var byteCharacters = atob(data);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], {
            type: "application/pdf",
          });
          window.navigator.msSaveOrOpenBlob(
            blob,
            this.props.DocumentContentRecord.Content_Title + ".pdf"
          );
          this.setState({ IENewWindow: true });
        } else {
          // Directly use base 64 encoded data for rest browsers (not IE)
          var base64EncodedPDF = data;
          var dataURI = "data:application/pdf;base64," + base64EncodedPDF;
          //document.getElementById('docIframe').src = (dataURI);
          this.setState({
            DocumentBlobData: dataURI,
          });
        }
      }
    });
  }

  _onClose() {
    this.props.hide();
  }

  render() {
    if (this.state.DocumentURL) {
      var dynamicIframe = (
        <iframe
          id="docIframe"
          style={{
            overflow: "scroll",
            height: "85vh",
            width: "90vw",
            display: "block",
          }}
          type="application/pdf"
          src={this.state.DocumentURL}
          allowFullScreen
          webkitallowFullScreen
          mozAllowFullScreen
        ></iframe>
      );
    }

    return (
      <Layer full="false" position="center">
        {/*  <Box
          align="center"
          justify="center"
          background={{ color: "brand" }}
          fill="horizontal"
        > */}
        <Box
          align="center"
          justify="between"
          direction="row"
          gap="medium"
          fill="horizontal"
          background={{ color: "brand" }}
        >
          <Heading size="small" level="4" margin="small">
            {this.props.DocumentContentRecord !== undefined
              ? this.props.DocumentContentRecord.Content_Title
              : this.props.DocTitle}
          </Heading>
          <Button icon={<Close />} secondary onClick={this._onClose} />
        </Box>
        {/* </Box> */}
        <Box align="center" justify="center" flex fill>
          {dynamicIframe}
          {/* <Iframe
            url={this.state.DocumentURL}
            position="absolute"
            width="80%"
            height="80%"
          /> */}
        </Box>
      </Layer>
    );
  }
}

export default DocumentHandler;
